import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { PremiumIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetUserQuery } from 'common';
import { moveToChangeSubscription, NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE, setAnalyticsLocation } from 'features/billing';
import { useGetNotetakerFreeMeetingsQuotaQuery, useGetMeetingIntelligenceUserSettingsQuery } from 'features/meeting_intelligence/api';
import { useEnableNotetakerWithLoader } from 'features/meeting_intelligence/hooks';
import { useNotetakerFiveFreeRecapsExperiment } from 'hooks/useNotetakerFiveFreeRecapsExperiment';
import { normalizeRecapsUsage } from './helpers';
const containerCss = "cdhfo4";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const FreeRecapsHeaderAction = ({
  paywallLocation
}) => {
  const dispatch = useDispatch();
  const enableNotetaker = useEnableNotetakerWithLoader();
  const {
    isInExperiment
  } = useNotetakerFiveFreeRecapsExperiment();
  const {
    data: userData
  } = useGetUserQuery();
  const {
    data: featureAvailability,
    isLoading: isQuotaLoading,
    error: isQuotaError
  } = useGetNotetakerFreeMeetingsQuotaQuery({
    userUuid: userData?.uuid
  }, {
    skip: !isInExperiment || !userData?.uuid
  });
  const featureAvailabilityDetails = featureAvailability?.resource?.details;
  const featureIsAvailable = featureAvailability?.resource?.featureAvailable;
  const {
    data: meetingIntelligenceData,
    isLoading: isMiLoading,
    error: isMiError
  } = useGetMeetingIntelligenceUserSettingsQuery(undefined, {
    skip: !isInExperiment || !userData?.uuid
  });
  const isMiEnabled = meetingIntelligenceData?.miEnabled;
  const userHasEnabledMiBefore = meetingIntelligenceData?.userHasEnabledMiBefore;
  const handleUpgrade = () => {
    if (paywallLocation) {
      dispatch(setAnalyticsLocation(paywallLocation));
    }
    dispatch(moveToChangeSubscription({
      featureKey: 'meeting_intelligence',
      preface: true,
      quotaAnalytics: {
        name: NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE,
        ...(featureIsAvailable !== undefined && {
          quotaReached: !featureIsAvailable
        })
      },
      ...(!isMiEnabled && {
        onSuccess: enableNotetaker
      })
    }));
  };

  // Never show if user is not in variant or user has not enabled MI before
  if (!isInExperiment || !userHasEnabledMiBefore) {
    return null;
  }
  if (isQuotaLoading || isQuotaError || isMiLoading || isMiError) {
    return null;
  }
  if (!featureIsAvailable && !isMiEnabled) {
    return null;
  }
  if (!featureAvailabilityDetails) {
    return null;
  }
  const normalized = normalizeRecapsUsage(featureAvailabilityDetails);
  if (!normalized) {
    return null;
  }
  const {
    usedRecaps,
    recapsQuota
  } = normalized;
  return <Container>
      <BodyText>
        {HtmlParser(I18n.t('publisher.meeting_intelligence.free_recaps.usage', {
        used: usedRecaps,
        total: recapsQuota
      }))}
      </BodyText>
      <Button decoration="meeting-intelligence" responsive={false} onClick={handleUpgrade}>
        <PremiumIcon size="standard" />
        {I18n.t('publisher.meeting_intelligence.free_recaps.upgrade_button')}
      </Button>
    </Container>;
};

require("./free_recaps_header_action.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./free_recaps_header_action.js");